<template>
  <div>
    <WebHeaderView :title="$t('menu.news')" />
    <div class="page-content">
      <van-tabs v-model="active" color="#fff" title-active-color="#fff">
        <van-tab
          v-for="(item, index) in types"
          :key="index"
          :name="item.key"
          :title="item.name"
        >
          <template #title>
            <div style="padding: 10px">
              <van-badge
                :content="
                  noticeList.filter(e => e.type == item.key && e.is_read != 1)
                    .length
                "
                :max="99"
                v-if="
                  noticeList.filter(e => e.type == item.key && e.is_read != 1)
                    .length > 0
                "
              >
                {{ item.name }}
              </van-badge>
              <span v-else>{{ item.name }}</span>
            </div>
          </template>
        </van-tab>
      </van-tabs>
      <div class="news-list">
        <div v-show="active != '-1'">
          <li
            v-for="(item, index) in noticeList.filter(e => e.type == active)"
            :key="index"
            class="news-item"
          >
            <div style="float: left">
              <van-badge dot v-if="item.is_read != 1"
                ><van-icon name="volume-o" size="32" color="#fff"
              /></van-badge>
              <van-icon v-else name="volume-o" size="32" color="#fff" />
            </div>
            <a
              @click="$router.push({ name: 'new',query:{id:item.id} });"
              style="flex: 1"
            >
              <div class="news-item-right">
                <div class="news-content-container">
                  <h4 class="new-title-wrapper">
                    <span class="title van-ellipsis">{{ item.title }}</span>
                    <span class="time van-ellipsis">{{ item.created_at }}</span>
                  </h4>
                  <div
                    class="news-content van-multi-ellipsis--l3"
                    v-html="item.content"
                  ></div>
                </div>
              </div>
            </a>
          </li>
        </div>
        <div v-show="active == '-1'">
          <div v-if="usrserve && usrserve.length > 0">
            <div
              class="customer-item"
              v-if="
                usrserve.filter(e => e.is_top == 1) &&
                usrserve.filter(e => e.is_top == 1).length > 0
              "
            >
              <div class="icon">
                <img :src="usrserve.filter(e => e.is_top == 1)[0].img" />
              </div>
              <div class="title" style="">
                <p>
                  {{ usrserve.filter(e => e.is_top == 1)[0].title }}
                </p>
                <p class="desc">
                  {{ usrserve.filter(e => e.is_top == 1)[0].content }}
                </p>
              </div>
              <div class="btn-box">
                <div class="btn">
                  <a :href="url" target="_bank"> 点击咨询专属客服</a>
                </div>
              </div>
            </div>
            <li
              v-for="(item, index) in usrserve.filter(e => e.is_top != 1)"
              :key="index"
              class="news-item"
            >
              <div class="customer-item">
                <div class="icon">
                  <img :src="item.img" />
                </div>
                <div class="title">
                  <p>
                    {{ item.title }}
                  </p>
                  <p class="desc">{{ item.content }}</p>
                </div>
                <div class="btn-box">
                  <div style="width: 90%; margin: 0 auto">
                    <div
                      style="
                        background-color: #cca352;
                        color: #fff;
                        float: left;
                        padding: 3px 8px;
                        border-radius: 5px;
                        margin-top: 6px;
                      "
                    >
                      助理推荐
                    </div>
                    <div
                      style="
                        float: right;
                        color: #fff;
                        margin-left: 5px;
                        height: 37px;
                        line-height: 37px;
                      "
                    >
                      {{ item.account
                      }}<span
                        @click="copy(item.account)"
                        style="
                          font-size: 12px;
                          margin-left: 4px;
                          color: #cca352;
                        "
                        >复制账号</span
                      >
                    </div>
                    <div style="clear: both" />
                  </div>
                  <div class="btn" v-if="item.download_describe && item.download_describe.length > 0">
                    <a
                      :href="item.download_url"
                      target="_bank"
                      style="color: #cca352"
                      >{{ item.download_describe }}</a
                    >
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'NewsView',
  components: { WebHeaderView },
  data () {
    return {
      noticeList: [],
      page: 1,
      types: [
       // { key: -1, name: this.$t('news.customer') },
        { key: 1, name: this.$t('news.notify') },
        { key: 2, name: this.$t('news.activity') },
        { key: 3, name: this.$t('news.placard') },
        { key: 4, name: this.$t('news.recommended') }
      ],
      active: -1,
      usrserve: null,
      url: null
    }
  },
  mounted () {
    this.getNotice()
    this.getCustomer()
  },
  methods: {
    async getNotice () {
      await this.$http({
        method: 'post',
        url: 'usrnotice',
        data: { page: 1, limit: 99999 }
      }).then(data => {
        this.noticeList = data.data.data
      })
    },
    async getCustomer () {
      await this.$http({
        method: 'get',
        url: 'getCustomer'
      }).then(data => {
        this.usrserve = data.data
        if (
          this.usrserve.filter(e => e.is_top == 1) &&
          this.usrserve.filter(e => e.is_top == 1).length > 0
        ) {
          this.url = this.usrserve.filter(e => e.is_top == 1)[0].url
        }
      })
    },
    copy (val) {
      var input = document.createElement('input')
      input.value = val
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      this.$toast.success('复制成功')
      document.body.removeChild(input)
    }
  }
}
</script>
<style lang="scss" scoped>
.news-list {
  height: calc(100vh - 2.6rem);
  overflow-y: auto;
  .customer-item {
    margin: 0.25rem;
    .icon {
      float: left;
      width: 1.4rem;
      height: 1.4rem;
      margin-right: 10px;
      margin-bottom: 10px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .title {
      height: 50px;
      float: left;
      width: calc(100% - 2rem);
      p {
        font-size: 18px;
        color: #fff;
        margin-top: 5px;
        text-align: left;
      }
      p.desc {
        font-size: 14px;
      }
    }
    .btn-box {
      border-bottom: 1px solid #666;
      padding: 10px 0;
      margin-top: 10px;
      clear: both;
      .btn {
        color: #cca352;
        border: 1px solid #cca352;
        padding: 8px 14px;
        text-align: center;
        width: 80%;
        margin: 10px auto;
        a {
          color: #cca352;
        }
      }
    }
  }
  .news-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #353535;
    position: relative;
    width: 90%;
    margin: 0 auto;
  }
  .news-item .circle-red {
    background: #ff3c2a;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .news-item .news-item-right {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    position: relative;
    padding-left: 13px;
    overflow: hidden;
  }
  .news-content-container {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    overflow: hidden;
    width: 100%;
  }
  .news-content-container .new-title-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-bottom: 6px;
  }

  .news-content-container .new-title-wrapper .title {
    max-width: 212px;
    overflow: hidden;
    font-size: 16px;
    line-height: 1;
    color: #fff;
  }
  .news-content-container .new-title-wrapper .time {
    font-size: 14px;
    color: #fff;
  }
  .news-content-container .news-content {
    overflow: hidden;
    font-size: 13px;
    line-height: 18px;
    color: #fff;
  }
}
</style>
